/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldGroup } from './DatabaseFieldGroup';
import {
    DatabaseFieldGroupFromJSON,
    DatabaseFieldGroupFromJSONTyped,
    DatabaseFieldGroupToJSON,
} from './DatabaseFieldGroup';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseSettingsFilter } from './DatabaseSettingsFilter';
import {
    DatabaseSettingsFilterFromJSON,
    DatabaseSettingsFilterFromJSONTyped,
    DatabaseSettingsFilterToJSON,
} from './DatabaseSettingsFilter';

/**
 * Additional settings for databases
 * @export
 * @interface DatabaseSettings
 */
export interface DatabaseSettings {
    /**
     * 
     * @type {number}
     * @memberof DatabaseSettings
     */
    maxFileSizeInMb?: number;
    /**
     * optional category field id to group entries by
     * @type {string}
     * @memberof DatabaseSettings
     */
    groupBy?: string;
    /**
     * sort entries by this field by default
     * @type {string}
     * @memberof DatabaseSettings
     */
    defaultSortBy?: string;
    /**
     * default sort direction
     * @type {string}
     * @memberof DatabaseSettings
     */
    defaultSortDirection?: DatabaseSettingsDefaultSortDirectionEnum;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseSettings
     */
    groupByFontSize?: DatabaseFontSizeEnum;
    /**
     * 
     * @type {Array<DatabaseFieldGroup>}
     * @memberof DatabaseSettings
     */
    fieldGroups?: Array<DatabaseFieldGroup>;
    /**
     * 
     * @type {Array<DatabaseSettingsFilter>}
     * @memberof DatabaseSettings
     */
    filters?: Array<DatabaseSettingsFilter>;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    withHeaderRow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    withSumRows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    hideChildDbView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    showPwaInstallButton?: boolean;
}


/**
 * @export
 */
export const DatabaseSettingsDefaultSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type DatabaseSettingsDefaultSortDirectionEnum = typeof DatabaseSettingsDefaultSortDirectionEnum[keyof typeof DatabaseSettingsDefaultSortDirectionEnum];


/**
 * Check if a given object implements the DatabaseSettings interface.
 */
export function instanceOfDatabaseSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSettingsFromJSON(json: any): DatabaseSettings {
    return DatabaseSettingsFromJSONTyped(json, false);
}

export function DatabaseSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maxFileSizeInMb': !exists(json, 'maxFileSizeInMb') ? undefined : json['maxFileSizeInMb'],
        'groupBy': !exists(json, 'groupBy') ? undefined : json['groupBy'],
        'defaultSortBy': !exists(json, 'defaultSortBy') ? undefined : json['defaultSortBy'],
        'defaultSortDirection': !exists(json, 'defaultSortDirection') ? undefined : json['defaultSortDirection'],
        'groupByFontSize': !exists(json, 'groupByFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['groupByFontSize']),
        'fieldGroups': !exists(json, 'fieldGroups') ? undefined : ((json['fieldGroups'] as Array<any>).map(DatabaseFieldGroupFromJSON)),
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(DatabaseSettingsFilterFromJSON)),
        'withHeaderRow': !exists(json, 'withHeaderRow') ? undefined : json['withHeaderRow'],
        'withSumRows': !exists(json, 'withSumRows') ? undefined : json['withSumRows'],
        'hideChildDbView': !exists(json, 'hideChildDbView') ? undefined : json['hideChildDbView'],
        'showPwaInstallButton': !exists(json, 'showPwaInstallButton') ? undefined : json['showPwaInstallButton'],
    };
}

export function DatabaseSettingsToJSON(value?: DatabaseSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maxFileSizeInMb': value.maxFileSizeInMb,
        'groupBy': value.groupBy,
        'defaultSortBy': value.defaultSortBy,
        'defaultSortDirection': value.defaultSortDirection,
        'groupByFontSize': DatabaseFontSizeEnumToJSON(value.groupByFontSize),
        'fieldGroups': value.fieldGroups === undefined ? undefined : ((value.fieldGroups as Array<any>).map(DatabaseFieldGroupToJSON)),
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(DatabaseSettingsFilterToJSON)),
        'withHeaderRow': value.withHeaderRow,
        'withSumRows': value.withSumRows,
        'hideChildDbView': value.hideChildDbView,
        'showPwaInstallButton': value.showPwaInstallButton,
    };
}

